import PropTypes from "prop-types";
import * as React from "react";
import {
  InfoIcon,
  CheckCircleIcon,
  WarningIcon,
  ErrorCircleIcon,
  CloseIcon,
} from "../../primitives/Icons/Icons";
import css from "./Alert.module.css";

const SEVERITY_ICON = {
  info: InfoIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorCircleIcon,
};

const SEVERITY_ROLE = {
  info: "status",
  success: "status",
  warning: "alert",
  error: "alert",
};

const Alert = React.forwardRef(
  (
    { severity = "info", title, icon, onClose, className, children, ...rest },
    ref,
  ) => {
    const IconComponent = icon === undefined ? SEVERITY_ICON[severity] : icon;

    return (
      <div
        ref={ref}
        role={SEVERITY_ROLE[severity]}
        className={[css.root, css[severity], className]
          .filter(Boolean)
          .join(" ")}
        {...rest}
      >
        {IconComponent && <IconComponent className={css.icon} />}
        <div className={css.content}>
          {title && <p className={css.title}>{title}</p>}
          {children && <div className={css.message}>{children}</div>}
        </div>
        {onClose && (
          <button
            type="button"
            className={css.close}
            onClick={onClose}
            aria-label="Dismiss alert"
          >
            <CloseIcon />
          </button>
        )}
      </div>
    );
  },
);

Alert.displayName = "Alert";

Alert.propTypes = {
  severity: PropTypes.oneOf(["info", "success", "warning", "error"]),
  title: PropTypes.node,
  icon: PropTypes.elementType,
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Alert;
